import api from '../utils/api';

export const checkLogin = () => {
    return api({
        url: '/api/checkuser/login',
        method: 'GET'
    })
}